import React, { FunctionComponent, useState, useEffect, useCallback } from "react";

import { Input, Button } from "@itwin/itwinui-react";
import { AbstractWidgetProps, StagePanelLocation, StagePanelSection, UiItemsProvider } from "@itwin/appui-abstract";
import { PropertyDescription, PropertyRecord, PropertyValue, PropertyValueFormat } from "@itwin/appui-abstract";
import { SimpleTableDataProvider, Table } from "@itwin/components-react";
import { ColumnDescription, RowItem, CellItem, FilterRenderer } from "@itwin/components-react";

import { cPropertiesApi } from "./PropertiesApi";
import { cSelection } from "./Selection";

import "./Search.scss";

export const SearchTableWidget: FunctionComponent<{tag: string}> = ({tag}) => {
  const dataProvider = (): SimpleTableDataProvider => {

    const columns: ColumnDescription[] = [];
    const columnProps: ColumnDescription = {
                  key: "", 
                  label: "", 
                  resizable: true, 
                  showFieldFilters: true, 
                  showDistinctValueFilters: true,
                  filterRenderer: FilterRenderer.MultiValue,
                  filterable: true, 
                  sortable: true,
                  editable: false,
                  filterCaseSensitive: false,
                  sortIgnoreCase: true,
                }

    const searchProps = cPropertiesApi.getSearchProperties();

    for (const prop of searchProps) {
      columns.push({ ... columnProps, 
                      key: prop.display, 
                      label: prop.display, 
                      width: prop.width}
                   )
    }

    const dataProvider: SimpleTableDataProvider = new SimpleTableDataProvider(columns);

    for (const row of cPropertiesApi.getSearchData()) {
      const rowItemKey = row.get("Tag");
      if (rowItemKey) {
        const rowItem: RowItem = { key: rowItemKey, cells: [] };
        for (const prop of searchProps) {
          const value = row.get(prop.property)!;
          rowItem.cells.push(cellItem(prop.display, prop.display, value));
        }
        dataProvider.addRow(rowItem);
      }
    }

    return dataProvider;
  }

  function cellItem(name: string, label: string, value: string) : CellItem {
    const propValue: PropertyValue = { 
            valueFormat: PropertyValueFormat.Primitive,
            value: value,
          }
    const description: PropertyDescription = {
            displayLabel: label,
            name: name,
            typename: "string",
          }
    const cell: CellItem = {
          key: name,
          record: new PropertyRecord(propValue, description),
        }

    return cell;
  }

  const _onRowsSelected = async (rowIterator: AsyncIterableIterator<RowItem>): Promise<boolean> => {

    const row = await rowIterator.next();
    const id = row.value.key;
    await cSelection.selectElementByTag(id);
    return true;
  }

//  const _getDataProvider = useCallback(dataProvider, [itemProps]);
  const _getDataProvider = useCallback(dataProvider, []);
  
  return (
    <>
      <div className={"table-box"}>
        <Table dataProvider={_getDataProvider()} onRowsSelected={_onRowsSelected} />
      </div>
    </>
  );
};

const SearchWidget: FunctionComponent = () => {
  const [_tag, setTag] = useState("");
  let keyword: string = "";

  useEffect(() => {
    // const searchHTML = document.getElementById("search") as HTMLInputElement
    // if (searchHTML) {
    //   searchHTML.value = _tag; //!!OA
    // }
  }, [_tag]);

  const onChangeSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    keyword = event.target.value;
//    if (keyword === "") await showSearch();  // when x in search box is clicked
    if (keyword === "") setTag(keyword);  // when x in search box is clicked
  }

  const onKeyDnSearch = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      await showSearch();
    }
  }

  const onButtonGoTo = async () => {
    await showSearch();
  }

  const showSearch = async() => {
    await cPropertiesApi.loadSearchData(keyword);
    setTag(keyword);
  }

  return (
    <div >
      <div className="search-options">
      <Input type="search" id="search" placeholder="Enter Tag/Id"
              onChange={onChangeSearch} onKeyDown={onKeyDnSearch}>
      </Input>
      <Button styleType="high-visibility" size="small" onClick={onButtonGoTo}>
              <span className="icon icon-zoom"> </span>
      </Button>
      </div>
      <hr/>
      <div>
      {_tag && <SearchTableWidget tag={_tag}/>}
      </div>
    </div>
  )
}

export class cSearchWidget implements UiItemsProvider {
  public readonly id = "SearchWidget";

  public provideWidgets(stageId: string, stageUsage: string, location: StagePanelLocation, section?: StagePanelSection) : ReadonlyArray<AbstractWidgetProps> {
    const widgets: AbstractWidgetProps[] = [];
    console.log(`Widget:stageId=${stageId} stageUsage=${stageUsage} location=${location} section=${section}`);

    if (location === StagePanelLocation.Right && section === StagePanelSection.Start) {
      const helloWidget: AbstractWidgetProps = {
        id: "SearchWidget",
        label: "Search",
        getWidgetContent() {
          return (
            <div>
            <SearchWidget/>
            </div>
          )
        }
      }

      widgets.push(helloWidget);
    }

    return widgets;
  }
}